import { Cookies } from "react-cookie";
import { LOGIN_REQUEST, LOGOUT } from "../../Constants/AuthConstants";

const cookies = new Cookies();

export const login = (loginData) => {
	return {
		type: LOGIN_REQUEST,
		data: loginData,
	};
};

export const logout = () => {
	localStorage.removeItem("persist:root");
	cookies.remove("jomtoken");
	return {
		type: LOGOUT,
	};
};
